import { render, staticRenderFns } from "./ExpenseCategoryList.vue?vue&type=template&id=0c8404ec&"
import script from "./ExpenseCategoryList.vue?vue&type=script&lang=js&"
export * from "./ExpenseCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports